export type LogoProps = React.HTMLAttributes<SVGElement>;

export const Logo = (props: LogoProps) => <p>S</p>;
